export default "__VITE_ASSET__BkXwySLC__"